const ServerHealthCheck = () => {
    return (
        <div className="bg-dark" style={{ paddingTop: "120px", minHeight: "60vh" }}>
            <section className="server-health-check bg-white">
                <div className="container my-5 py-5">
                    <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: "500px"}}>
                        <div className="d-inline-block rounded-pill bg-important text-important py-1 px-3 mb-3">Server Health Check</div>
                        <h3 className="mb-2">System status is fine.</h3>
                    </div>
                    <h5 className="text-center fw-light mb-2">Manual Update Logs</h5>
                    <div className="row border">
                        <div className="col-md-6 text-center border-end">
                            5:00 PM, 9 Aug 2025
                        </div>
                        <div className="col-md-6 px-5">
                            Added manual logs for server health check. All systems operational.
                        </div>
                    </div>
                    <div className="row border">
                        <div className="col-md-6 text-center border-end">
                            3:06 PM, 23 Aug 2025
                        </div>
                        <div className="col-md-6 px-5">
                            Added CI for frontend and backend
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default ServerHealthCheck;
